import { CognitoUser } from "@aws-amplify/auth"

export enum UserType {
    unresolved = "unresolved",
    anonymous = "anonymous",
    member = "member",
    unconfirmed = "unconfirmed"
}

export type OTPSession = {
    code?: string
    currentUser: AuthUser
}

export type AuthChallengeName =
    | "NEW_PASSWORD_REQUIRED"
    | "SMS_MFA"
    | "SOFTWARE_TOKEN_MFA"
    | "MFA_SETUP"

export type AuthUser = CognitoUser & {
    username: string
    challengeName: AuthChallengeName
}

export type User = MemberUser | UnresolvedUser | AnonymousUser | UnconfirmedUser

export interface MemberUser {
    type: UserType.member
    isSigningOut: boolean
}

export interface UnresolvedUser {
    type: UserType.unresolved
    isResumingSession: boolean
}

export interface AnonymousUser {
    type: UserType.anonymous
    isSigningIn: boolean
    isSigningUp: boolean
    session?: OTPSession
}

export interface UnconfirmedUser {
    type: UserType.unconfirmed
    email: string
    password: string
}
